export default __webpack_public_path__ + "static/media/arte-bg-home.ddfe3a22.svg";